import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match, Switch } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ListaPaquetesPP } from "./list";
import { NuevoPaquete } from "./edit";
import { PaquetePPDetalle } from "./ver";

export class PaquetesPPIndex extends React.Component<{ match: match<{}> }> {
    render() {
        const path = this.props.match.path;
        return (
            <div>
                <Switch>
                    <Route exact path={path} component={ListaPaquetesPP} />
                    <Route path={path + "/new"} component={NuevoPaquete} />
                    <Route path={path + "/:id"} component={PaquetePPDetalle} />
                </Switch>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/index.tsx